import { ajax } from "@/plugins/ajax";

export default {
  namespaced: true,
  state: {
    list: [],
    details: []
  },
  getters: {
    list: state => state.list,
    details: state => state.details
  },
  actions: {
    fetchSingle({ commit }, id) {
      return new Promise((resolve, reject) => {
        ajax
          .get("ProductManagement/api/PicturesQuery/" + id)
          .then(r => {
            commit("setDetails", r.data);
            resolve(r.data);
          })
          .catch(e => reject(e));
      });
    },
    fetchVideo({ commit }, id) {
      return new Promise((resolve, reject) => {
        ajax
          .get("ProductManagement/api/VideosQuery/" + id)
          .then(r => {
            commit("setDetails", r.data);
            resolve(r.data);
          })
          .catch(e => reject(e));
      });
    },
    create({ commit, dispatch }, model) {
      return ajax.post("ProductManagement/api/Pictures", model);
    },
    createVideo({ commit, dispatch }, model) {
      return ajax.post("ProductManagement/api/Videos", model);
    },
    remove({ commit, dispatch }, { productId, name }) {
      return new Promise((resolve, reject) => {
        ajax
          .delete(
            "ProductManagement/api/Pictures",
            { data: { productId: productId, name: name } },
            { headers: { "Content-Type": "application/json" } }
          )
          .then(() => {
            dispatch("fetchSingle", productId)
              .then(picture => {
                resolve(picture);
              })
              .catch(e => reject(e));
          })
          .catch(e => reject(e));
      });
    },
    removeVideo({ commit, dispatch }, { productId, name }) {
      return new Promise((resolve, reject) => {
        ajax
          .delete(
            "ProductManagement/api/Videos",
            { data: { productId: productId, name: name } },
            { headers: { "Content-Type": "application/json" } }
          )
          .then(() => {
            dispatch("fetchVideo", productId)
              .then(video => {
                resolve(video);
              })
              .catch(e => reject(e));
          })
          .catch(e => reject(e));
      });
    },
    update({ commit, dispatch }, model) {
      return ajax.put("ProductManagement/api/Pictures", model).then(() => {});
    }
  },
  mutations: {
    setList(state, data) {
      state.list = data;
    },
    setDetails(state, data) {
      state.details = data;
    }
  }
};
